module.exports = __webpack_public_path__ + "static/attendee.de2b1584.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Viewport/attendee.png
// module id = 674
// module chunks = 213534597649335